import { faPlay as fasPlay } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";
import type { AbstractStepProps } from "@/component/assets/AbstractLeadForm/Steps/AbstractStep";
import { AbstractStep } from "@/component/assets/AbstractLeadForm/Steps/AbstractStep";
import imgBankszamlaLogo from "@/img/cibeco/logo-replace.png";
import cibEcoBadge from "@/img/landing/bankszamla/cib/cib_eco_badge.svg";
import bankmonitorImage from "@/img/logos/bankmonitor-white.svg";
import { ButtonLegacy, List } from "@/shared/ui";
import { faBankmonitor } from "@/shared/ui/fortawesome/bankmonitor";

type StepFields = {};

interface Props extends AbstractStepProps {
	variant?: string;
}

export class StartScreen extends AbstractStep<StepFields, Props> {
	protected renderContent(): ReactNode {
		switch (this.props.variant) {
			case "cib-eco-lead":
				return this.renderCibLead();
			case "cib-eco-plus":
				return this.renderCibEcoPlusLead();
			case "unicredit":
				return this.renderUnicreditLead();
			case "raiffeisen":
				return this.renderRaiffeisenLead();
			case "erste":
				return this.renderErsteLead();
			default:
				return this.renderSimpleLead();
		}
	}

	private renderCibLead(): ReactNode {
		return (
			<>
				<Card.Body className="d-flex flex-column">
					<div className="only-bm font-weight-normal text-secondary d-flex justify-content-center align-items-center pb-1">
						<FontAwesomeIcon icon={faBankmonitor} className="mr-2" />
						KIZÁRÓLAG A BANKMONITORNÁL!
					</div>
					<strong className="h3 d-block pb-2 text-center text-secondary">0-24 online kötés</strong>
					<img src={imgBankszamlaLogo} alt="Bankszámla igénylés" width={318} height={100} loading="eager" />
					<div className="my-auto text-center">
						<img src={cibEcoBadge} width={220} alt="CIB ECO" loading="eager" />
					</div>
				</Card.Body>
				<Card.Footer className="text-center">
					<ButtonLegacy
						className="font-weight-bold stretched-link"
						type="button"
						variant="secondary"
						icon={<FontAwesomeIcon icon={fasPlay} />}
						onClick={() => this.onStep("step-1", false)}
					>
						IGÉNYLÉS INDÍTÁSA
					</ButtonLegacy>
				</Card.Footer>
			</>
		);
	}

	private renderUnicreditLead(): ReactNode {
		return (
			<>
				<Card.Body className="d-flex flex-column">
					<div className="h4 font-weight-normal text-secondary d-flex justify-content-center align-items-center pb-1">
						<FontAwesomeIcon icon={faBankmonitor} className="mr-2" />
						KIZÁRÓLAG A BANKMONITORNÁL!
					</div>
					<div className="my-auto">
						<h4 className="h3 d-block mb-0 pb-2 text-center text-secondary">
							teljesen online számlanyitás
						</h4>
						<img
							src={imgBankszamlaLogo}
							alt="Bankszámla igénylés"
							width={318}
							height={100}
							loading="eager"
						/>
					</div>
					<div className="mb-5 text-center">
						<p className="text-secondary display-6">
							...és közben megnézheted, hogy van-e számodra jobb számla, mint a 2 évig díjmentes UniCredit
							Partner Aktív Nulla.
						</p>
					</div>
				</Card.Body>
				<Card.Footer className="text-center">
					<ButtonLegacy
						className="font-weight-bold stretched-link"
						type="button"
						variant="secondary"
						icon={<FontAwesomeIcon icon={fasPlay} />}
						onClick={() => this.onStep("step-1", false)}
					>
						IGÉNYLÉS INDÍTÁSA
					</ButtonLegacy>
				</Card.Footer>
			</>
		);
	}

	private renderCibEcoPlusLead(): ReactNode {
		return (
			<>
				<Card.Body className="d-flex flex-column">
					<div className="h4 font-weight-normal text-secondary d-flex justify-content-center align-items-center pb-1">
						<FontAwesomeIcon icon={faBankmonitor} className="mr-2" />
						KIZÁRÓLAG A BANKMONITORNÁL!
					</div>
					<div className="my-auto">
						<h4 className="h3 d-block mb-0 pb-2 text-center text-secondary">0-24 online számlanyitás</h4>
						<img
							src={imgBankszamlaLogo}
							alt="Bankszámla igénylés"
							width={318}
							height={100}
							loading="eager"
						/>
					</div>
					<div className="mb-5 text-center">
						<p className="text-secondary display-6">
							5 évig ingyenes bankszámla, arany bankkártyával. Nézd meg, hogy van-e jobb ajánlat számodra.
						</p>
					</div>
				</Card.Body>
				<Card.Footer className="text-center">
					<ButtonLegacy
						className="font-weight-bold stretched-link"
						type="button"
						variant="secondary"
						icon={<FontAwesomeIcon icon={fasPlay} />}
						onClick={() => this.onStep("step-1", false)}
					>
						IGÉNYLÉS INDÍTÁSA
					</ButtonLegacy>
				</Card.Footer>
			</>
		);
	}

	private renderRaiffeisenLead(): ReactNode {
		return (
			<>
				<Card.Body className="d-flex flex-column">
					<div className="h4 font-weight-normal text-uppercase text-secondary d-flex justify-content-center align-items-center pb-1">
						<FontAwesomeIcon icon={faBankmonitor} className="mr-2" />
						Igényeld a Bankmonitornál!
					</div>
					<div className="my-auto">
						<img
							src={imgBankszamlaLogo}
							alt="Bankszámla igénylés"
							width={318}
							height={100}
							loading="eager"
						/>
					</div>
					<div className="mb-5 text-center">
						<p>
							<p className="display-6">
								<strong>Ingyenes bankszámla</strong> az igényeidre szabva:
								<br />
								Nézd meg melyik a <strong>legjobb bankszámla</strong> számodra és{" "}
								<strong>takaríts meg banki költségeidből!</strong>
							</p>
						</p>
					</div>
				</Card.Body>
				<Card.Footer className="text-center">
					<ButtonLegacy
						className="font-weight-bold stretched-link text-uppercase"
						type="button"
						variant="primary"
						icon={<FontAwesomeIcon icon={fasPlay} />}
						onClick={() => this.onStep("step-1", false)}
					>
						Igénylés indítása
					</ButtonLegacy>
				</Card.Footer>
			</>
		);
	}

	private renderErsteLead(): ReactNode {
		return (
			<>
				<Card.Body className="d-flex flex-column">
					<div className="h4 font-weight-normal text-uppercase text-secondary d-flex justify-content-center align-items-center pb-1">
						<FontAwesomeIcon icon={faBankmonitor} className="mr-2" />
						Igényeld a Bankmonitornál!
					</div>
					<div className="my-auto">
						<img
							src={imgBankszamlaLogo}
							alt="Bankszámla igénylés"
							width={318}
							height={100}
							loading="eager"
						/>
					</div>
					<div className="mb-5 text-center">
						<p className="text-secondary display-6">
							<strong>Ingyenes bankszámla</strong> induló jóváírással. Megspórolhatod a számla költségeket
							és még <strong>40 ezer Ft jóváírást is kaphatsz!</strong>
						</p>
					</div>
				</Card.Body>
				<Card.Footer className="text-center">
					<ButtonLegacy
						className="font-weight-bold stretched-link text-uppercase"
						type="button"
						variant="secondary"
						icon={<FontAwesomeIcon icon={fasPlay} />}
						onClick={() => this.onStep("step-1", false)}
					>
						Igénylés indítása
					</ButtonLegacy>
				</Card.Footer>
			</>
		);
	}

	private renderSimpleLead(): ReactNode {
		return (
			<>
				<Card.Header className="text-center bg-secondary-gradient">
					<img src={bankmonitorImage} alt="Bankmonitor" width={159} height={24} loading="eager" />
					<hr />
					<div className="h2 mb-0 text-uppercase text-white">
						Bankszámla <br />
						kalkulátor
					</div>
					<hr />
				</Card.Header>
				<Card.Body className="d-flex flex-column start-screen-body">
					<List
						itemStyle="tick"
						variant="primary"
						size="lg"
						className="font-weight-light mx-2 my-auto"
						spacing="lg"
					>
						<List.Item>
							Nézd meg, számodra melyik a <strong>legjobb bankszámla</strong>!
						</List.Item>
						<List.Item>
							Neked is lehet <strong>ingyenes</strong> a bankszámlád?
						</List.Item>
						<List.Item>
							Akár <strong>több tízezer forintot</strong> is <strong>megtakaríthatsz</strong>{" "}
							bankköltségeidből!
						</List.Item>
					</List>
				</Card.Body>
				<Card.Footer className="text-center">
					<ButtonLegacy type="submit" icon={<FontAwesomeIcon icon={fasPlay} />} className="text-uppercase">
						Kalkuláció indítása
					</ButtonLegacy>
				</Card.Footer>
			</>
		);
	}

	protected getComponentName(): string {
		return "StartScreen";
	}
}
